module.exports = __webpack_public_path__ + "img/lattes-verde.62cf7f37.png";